'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      shape = _baseTheme$vstui.shape,
      typography = _baseTheme$vstui.typography,
      cloud2 = color.cloud.getShade(2),
      cloud3 = color.cloud.getShade(3),
      cloud4 = color.cloud.getShade(4),
      cloud9 = color.cloud.getShade(9);
  return (0, _themes.createComponentTheme)(baseTheme, {
    Table_borderRadius: shape.borderRadius,
    Table_fontFamily: typography.fontFamily,
    Table_fontSize: typography.fontSize,
    Table_fontWeight: typography.fontWeightRegular,
    TableDataCell_backgroundColor: color.surface,
    TableDataCell_backgroundColor_primary_hover: color.surface,
    TableDataCell_backgroundColor_secondary_hover: color.surface,
    TableDataCell_borderColor: cloud3,
    TableDataCell_color: color.onSurface,
    TableDataCell_fontFamily: typography.fontFamily,
    TableDataCell_fontSize: typography.fontSize,
    TableDataCell_fontWeight: typography.fontWeightRegular,
    TableHeaderCell_backgroundColor: cloud2,
    TableHeaderCell_borderColor: cloud4,
    TableHeaderCell_color: cloud9,
    TableHeaderCell_fontFamily: typography.fontFamily,
    TableHeaderCell_fontSize: typography.fontSize - 1,
    TableHeaderCell_fontWeight: typography.fontWeightRegular
  });
};

exports.default = componentTheme;